import React from 'react'

import useTranslate from 'Pods/SearchPage/Shared/useTranslate'
import {
  setMultiColor, setThreeDPrintVerified, setWithMakes,
} from 'Pods/SearchPage/Store/actions/threeDPrintOnly'

import PrintAttributesChip from './PrintAttributesChip'

const CHIPS = [
  { key: 'with_makes', select: state => state.withMakes, onChange: setWithMakes },
  { key: 'three_d_print_verified', select: state => state.threeDPrintVerified, onChange: setThreeDPrintVerified },
  { key: 'multi_color', select: state => state.multiColor, onChange: setMultiColor },
]

function PrintAttributes() {
  const translate = useTranslate()

  return (
    <div
      className="print-attributes"
      role="group"
      aria-label={translate('search_page.filters.print_attributes.group_label')}
    >
      {CHIPS.map(({ key, select, onChange }) => (
        <PrintAttributesChip
          key={key}
          chipKey={key}
          select={select}
          onChange={onChange}
        />
      ))}
    </div>
  )
}

export default PrintAttributes
